import React from 'react';

interface TagProps extends React.HTMLAttributes<HTMLSpanElement> {
  className?: string;
  children: React.ReactNode;
  variant?: 'default' | 'support' | 'coaching';
}

const Tag = React.forwardRef<HTMLSpanElement, TagProps>(
  ({ className = '', variant = 'default', children, ...props }, ref) => {
    const baseStyles = 'inline-flex items-center rounded-pill px-3 py-1 text-sm';
    
    const variantStyles = {
      default: 'bg-rm-teal-600/10 text-rm-teal-600',
      support: 'bg-rm-accent-300/20 text-rm-primary-700',
      coaching: 'bg-rm-primary-700/10 text-rm-primary-700',
    };
    
    const classes = [baseStyles, variantStyles[variant], className].filter(Boolean).join(' ');

    return (
      <span ref={ref} className={classes} {...props}>
        {children}
      </span>
    );
  }
);

Tag.displayName = 'Tag';

export { Tag };
export type { TagProps };